import React from 'react';
import {
  Star,
  ShoppingCart,
  Heart,
  Eye,
  Zap,
  Award,
  Truck
} from 'lucide-react';

const FeaturedProducts = ({ addToCart, addToFavorites, favorites }) => {
  const products = [
    {
      id: 1,
      name: 'فيتامين د3 5000 وحدة',
      brand: 'Nature Made',
      price: 89.99,
      originalPrice: 120.00,
      rating: 4.8,
      reviews: 245,
      badge: 'الأكثر مبيعاً',
      badgeColor: 'bg-red-500',
      inStock: true,
      fastDelivery: true,
      imageSrc: 'https://images.unsplash.com/photo-1697273245326-1a3736f6f428?w=800&q=80&fit=crop&auto=format'
    },
    {
      id: 2,
      name: 'أوميجا 3 فيش أويل',
      brand: 'Nordic Naturals',
      price: 156.50,
      rating: 4.9,
      reviews: 189,
      badge: 'جودة عالية',
      badgeColor: 'bg-[#10B981]',
      inStock: true,
      fastDelivery: true,
      imageSrc: 'https://images.unsplash.com/photo-1670850757263-6efc07d410f8?w=800&q=80&fit=crop&auto=format'
    },
    {
      id: 3,
      name: 'مقياس ضغط الدم الرقمي',
      brand: 'Omron',
      price: 299.99,
      originalPrice: 350.00,
      rating: 4.7,
      reviews: 156,
      badge: 'عرض محدود',
      badgeColor: 'bg-orange-500',
      inStock: true,
      fastDelivery: false,
      imageSrc: 'https://images.unsplash.com/photo-1725870953863-4ad4db0acfc2?w=800&q=80&fit=crop&auto=format'
    },
    {
      id: 4,
      name: 'كريم مرطب للبشرة الحساسة',
      brand: 'CeraVe',
      price: 67.50,
      originalPrice: 85.00,
      rating: 4.6,
      reviews: 324,
      badge: 'مُوصى به',
      badgeColor: 'bg-indigo-500',
      inStock: true,
      fastDelivery: true,
      imageSrc: 'https://tse4.mm.bing.net/th/id/OIP.GcwoKDpjod8_WPN1rFg-GwHaHa?r=0&rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      id: 5,
      name: 'مكمل الكالسيوم والمغنيسيوم',
      brand: 'Garden of Life',
      price: 134.99,
      rating: 4.5,
      reviews: 98,
      badge: 'جديد',
      badgeColor: 'bg-purple-500',
      inStock: true,
      fastDelivery: true,
      imageSrc: 'https://images.unsplash.com/photo-1682978900142-9ab110f7a868?w=800&q=80&fit=crop&auto=format'
    },
    {
      id: 6,
      name: 'ميزان حرارة رقمي',
      brand: 'Braun',
      price: 89.00,
      originalPrice: 110.00,
      rating: 4.8,
      reviews: 267,
      badge: 'خصم 19%',
      badgeColor: 'bg-red-500',
      inStock: false,
      fastDelivery: false,
      imageSrc: 'https://images.unsplash.com/photo-1609725236589-d987ffc8133a?w=800&q=80&fit=crop&auto=format'
    }
  ];

  const favoriteIds = new Set(favorites.map((item) => item.id));

  return (
    <section className="bg-gray-50 pt-16 pb-8 font-['Cairo'] lg:pt-24 lg:pb-12">
      <div className="container mx-auto px-4">
        <div className="mb-16 text-center">
          <div className="mb-4 flex items-center justify-center gap-2">
            <Award className="h-6 w-6 text-[#10B981]" />
            <span className="font-semibold text-[#10B981]">المنتجات المميزة</span>
          </div>
          <h2 className="mb-4 text-3xl font-bold text-gray-900 lg:text-4xl">
            الأكثر طلباً من عملائنا
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            منتجات مختارة بعناية من أفضل العلامات التجارية العالمية بأسعار تنافسية
          </p>
        </div>

        <div className="mb-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {products.map((product) => (
            <div
              key={product.id}
              className="group overflow-hidden rounded-2xl bg-white shadow-md ring-1 ring-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:ring-[#10B981]/20"
            >
              <div className="relative">
                <div className="relative h-64 overflow-hidden bg-gray-100">
                  <img
                    src={product.imageSrc}
                    alt={product.name}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  <div
                    className={`absolute right-3 top-3 rounded-full ${product.badgeColor} px-3 py-1 text-xs font-semibold text-white shadow-sm`}
                  >
                    {product.badge}
                  </div>

                  <div className="absolute left-3 top-3 flex translate-x-[-4px] flex-col gap-2 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100">
                    <button
                      className="flex h-9 w-9 items-center justify-center rounded-full bg-white/95 shadow-sm transition-all duration-200 hover:bg-white hover:shadow-md active:scale-95"
                      onClick={() => addToFavorites(product)}
                      aria-label="أضف إلى المفضلة"
                    >
                      <Heart
                        className={`h-4 w-4 transition-colors ${
                          favoriteIds.has(product.id) ? 'fill-current text-red-500' : 'text-gray-500'
                        }`}
                      />
                    </button>
                    <button
                      className="flex h-9 w-9 items-center justify-center rounded-full bg-white/95 shadow-sm transition-all duration-200 hover:bg-white hover:shadow-md active:scale-95"
                      aria-label="عرض سريع"
                    >
                      <Eye className="h-4 w-4 text-gray-500" />
                    </button>
                  </div>

                  {!product.inStock && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                      <span className="rounded-lg bg-red-500 px-4 py-2 font-semibold text-white">
                        غير متوفر
                      </span>
                    </div>
                  )}
                </div>

                <div className="p-6">
                  <p className="mb-1 text-sm text-gray-500">{product.brand}</p>
                  <h3 className="mb-2 line-clamp-2 text-lg font-bold text-gray-900 transition-colors group-hover:text-[#10B981]">
                    {product.name}
                  </h3>

                  <div className="mb-3 flex items-center gap-2">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'fill-current' : 'text-gray-300'}`}
                        />
                      ))}
                    </div>
                    <span className="text-sm text-gray-500">
                      {product.rating} ({product.reviews})
                    </span>
                  </div>

                  <div className="mb-4 flex items-center gap-2">
                    <span className="text-2xl font-bold text-[#10B981]">{product.price} ر.س</span>
                    {product.originalPrice && (
                      <span className="text-base text-gray-400 line-through">
                        {product.originalPrice} ر.س
                      </span>
                    )}
                  </div>

                  <div className="mb-4 flex items-center gap-4 text-sm">
                    {product.fastDelivery && (
                      <div className="flex items-center gap-1 text-[#10B981]">
                        <Truck className="h-4 w-4" />
                        <span>توصيل سريع</span>
                      </div>
                    )}
                    {product.inStock && (
                      <div className="flex items-center gap-1 text-indigo-600">
                        <Zap className="h-4 w-4" />
                        <span>متوفر</span>
                      </div>
                    )}
                  </div>

                  <button
                    onClick={() => product.inStock && addToCart(product)}
                    className={`flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3 font-bold transition-all duration-300 ${
                      product.inStock
                        ? 'bg-[#10B981] text-white shadow-sm shadow-[#10B981]/20 hover:bg-[#0ea173] hover:shadow-lg hover:shadow-[#10B981]/25 active:scale-[0.98]'
                        : 'cursor-not-allowed bg-gray-200 text-gray-400'
                    }`}
                    disabled={!product.inStock}
                  >
                    <ShoppingCart className="h-4 w-4" />
                    {product.inStock ? 'أضف للسلة' : 'غير متوفر'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="rounded-xl border-2 border-[#10B981] px-8 py-4 text-lg font-bold text-[#10B981] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#10B981] hover:text-white hover:shadow-lg hover:shadow-[#10B981]/20">
            عرض جميع المنتجات
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
